import { render, staticRenderFns } from "./card-debug.vue?vue&type=template&id=534df3da&scoped=true&"
import script from "./card-debug.vue?vue&type=script&lang=js&"
export * from "./card-debug.vue?vue&type=script&lang=js&"
import style0 from "./card-debug.vue?vue&type=style&index=0&id=534df3da&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534df3da",
  null
  
)

export default component.exports